import React from 'react';
import { createBrowserHistory } from 'history';
import Router from './Router';
import { StoreProvider } from '@ui/providers/Store.provider';
import RouterProvider from '@ui/providers/Router.provider';
import { rootStore } from '@store/Root.store';

const history = createBrowserHistory();

const App = () => {
    return (
        <StoreProvider value={rootStore}>
            <RouterProvider basename="/" history={history}>
                <Router />
            </RouterProvider>
        </StoreProvider>
    );
};

export default App;
